import createMessageString from '@utilities/errors/create-message-string'
import addAlertMessage from '../add-alert-message'

/**
 * Process API error
 *
 * @param {Object|String} error - error message
 * @param {string} selector - error message selector
 */
const apiErrorHandler = function (error, selector) {
  if (!error) return
  const { redirectUrl } = error
  if (redirectUrl) {
    window.location.href = redirectUrl
  } else if (error.serverErrors && error.serverErrors.length) {
    addAlertMessage({
      message: createMessageString(error.serverErrors),
      hook: selector,
      type: 'error',
      scroll: 'true'
    })
  } else {
    const errorMessage = error.errorMessage || error.message || error.responseJSON
    if (!errorMessage) return
    addAlertMessage({ message: errorMessage, hook: selector, type: 'error', scroll: 'true' })
  }
}

export default apiErrorHandler
